export default "__VITE_ASSET__$fcfoTDA__"